import { colors } from '../../../theme/tokens/colors';
import { chat as defaultAccent } from '../../../theme/tokens/semantic';

export function createAnalyticsSx(tokenOverrides = {}) {
  const accent = tokenOverrides.accent ?? defaultAccent;

  return {
    pageRoot: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100%',
      px: { xs: 2, md: 3 },
      pt: 2.5,
      pb: 4,
      gap: 2,
      mb:2
    },
    pageTitle: {
      fontWeight: 700,
      color: accent.textPrimary ?? colors.grey[900],
    },
    sectionCard: {
      border: '1px solid',
      borderColor: accent.divider ?? colors.grey[200],
      borderRadius: 1,
      p: 2,
      bgcolor: colors.white,
    },
    datasetCard: {
      border: '1px solid',
      borderColor: accent.divider ?? colors.grey[200],
      borderRadius: 1.5,
      p: 2,
      cursor: 'pointer',
      bgcolor: colors.white,
      transition: 'border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease',
      '&:hover': {
        borderColor: accent.primary ?? colors.grey[600],
      },
      '&.Mui-focusVisible': {
        outline: `2px solid ${accent.primary ?? colors.grey[600]}`,
        outlineOffset: 2,
      },
    },
    datasetCardSelected: {
      borderColor: accent.primary ?? colors.grey[600],
      boxShadow: `0 0 0 1px ${accent.primary ?? colors.grey[600]}`,
      bgcolor: accent.primarySurface ?? 'action.hover',
    },
    pinnedGrid: {
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: '1fr 1fr 1fr' },
      gap: 2,
    },
    stepIconBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 40,
      height: 40,
      borderRadius: 1,
      bgcolor: 'action.hover',
      color: 'primary.main',
      flexShrink: 0,
    },
    chartColors: tokenOverrides.chartColors || [
      accent.primary ?? colors.grey[800],
      accent.secondary ?? colors.grey[600],
      colors.grey[500],
    ],
    chartTypeCard: {
      border: '1px solid',
      borderColor: accent.divider ?? colors.grey[200],
      borderRadius: 1,
      p: 1.5,
      height: '100%',
      cursor: 'pointer',
      transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
      '&:hover': {
        borderColor: accent.primary ?? colors.grey[600],
      },
    },
    chartTypeCardSelected: {
      borderColor: accent.primary ?? colors.grey[800],
      boxShadow: `0 0 0 1px ${accent.primary ?? colors.grey[800]}`,
      bgcolor: 'action.hover',
    },
    chartTypeIconWrap: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      borderRadius: 1,
      bgcolor: 'action.selected',
      color: 'primary.main',
    },
    scopeContextBanner: {
      border: '1px dashed',
      borderColor: accent.divider ?? colors.grey[300],
      borderRadius: 1,
      p: 2,
      bgcolor: colors.grey[50] ?? 'action.hover',
    },
    previewCanvas: {
      bgcolor: colors.grey[50] ?? '#fafafa',
    },
    previewCanvasInner: {
      maxWidth: 900,
      mx: 'auto',
    },
  };
}
